routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.sales', {
      url: "ofertas",
      template: `<sales sh-ctrl="shCtrl"></sales>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/sales/sales.config.js
 **/